/* eslint-disable no-unused-vars  */
export enum ComponentEvents {
  INITIALISED = 'COMPONENT::INITIALISED',
  READY = 'COMPONENT::READY',
  VIEWPORT_ENTER = 'COMPONENT::VIEWPORT_ENTER',
  VIEWPORT_LEAVE = 'COMPONENT::VIEWPORT_LEAVE',
  SHOWN = 'COMPONENT::SHOWN',
}
